import Hashids from "hashids";
const hashids = new Hashids('qushixi_saas',10)

export const encode = id => {
    return hashids.encode(id)
}
export const decode = enc => {
    return hashids.decode(enc)[0]
}